/**
 * 业务里常见的中文词组 → 英文（用于「系统词翻译 + 用户片段拼音」混合展示）
 * 匹配时按 zh 长度降序，避免短词抢先破坏长词（如「方案」应先于「公共用电方案」中的子串被整体替换）。
 */
export const ZH_EN_BUSINESS_PHRASES = [
  { zh: '公共用电分摊组', en: 'Public power allocation' },
  { zh: '公共用电方案', en: 'Public power plan' },
  { zh: '专用表通用方案', en: 'Dedicated meter default plan' },
  { zh: '公摊表通用方案', en: 'Shared meter default plan' },
  { zh: '公式表通用方案', en: 'Formula meter default plan' },
  { zh: '空调表通用方案', en: 'HVAC meter default plan' },
  { zh: '租户计费方案', en: 'Tenant billing plan' },
  { zh: '用电方案', en: 'power plan' },
  { zh: '电费方案', en: 'tariff plan' },
  { zh: '水费方案', en: 'water tariff plan' },
  { zh: '通用方案', en: 'default plan' },
  { zh: '计费方案', en: 'billing plan' },
  { zh: '测试方案', en: 'test plan' },
  { zh: '公共用电', en: 'Public power' },
  { zh: '租户用电', en: 'Tenant power' },
  { zh: '租户用水', en: 'Tenant water' },
  { zh: '设备用水', en: 'Equipment water' },
  { zh: '设备用电', en: 'Equipment power' },
  { zh: '公共照明', en: 'Public lighting' },
  { zh: '会议接待厅', en: 'Meeting reception' },
  { zh: '市场营销部', en: 'Marketing dept.' },
  { zh: '技术研发部', en: 'R&D dept.' },
  { zh: '行政办公室', en: 'Admin office' },
  { zh: '展销大厅', en: 'Exhibition hall' },
  { zh: '办公室', en: 'office' },
  { zh: '公摊组', en: 'allocation group' },
  { zh: '分摊组', en: 'sharing group' },
  { zh: '专用表', en: 'Dedicated meter' },
  { zh: '公摊表', en: 'Shared meter' },
  { zh: '公式表', en: 'Formula meter' },
  { zh: '空调表', en: 'HVAC meter' },
  { zh: '水表', en: 'Water meter' },
  { zh: '电表', en: 'Power meter' },
  { zh: '租户', en: 'Tenant' },
  { zh: '公共', en: 'Public' },
  { zh: '公摊', en: 'Shared' },
  { zh: '专用', en: 'Dedicated' },
  { zh: '公式', en: 'Formula' },
  { zh: '空调', en: 'HVAC' },
  { zh: '用电', en: 'power use' },
  { zh: '用水', en: 'water use' },
  { zh: '照明', en: 'Lighting' },
  { zh: '方案', en: 'plan' },
  { zh: '计费', en: 'billing' },
  { zh: '电费', en: 'tariff' },
  { zh: '水费', en: 'water fee' },
  { zh: '分摊', en: 'allocation' },
  { zh: '测试', en: 'test' }
]
